import React from 'react'

export function IconCity() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M1.25 21a.75.75 0 01.75-.75h20a.75.75 0 010 1.5H2a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5 13.75a.25.25 0 00-.25.25v6c0 .138.112.25.25.25h2a.25.25 0 00.25-.25v-6a.25.25 0 00-.25-.25H5zM3.25 14c0-.966.784-1.75 1.75-1.75h2c.966 0 1.75.784 1.75 1.75v6A1.75 1.75 0 017 21.75H5A1.75 1.75 0 013.25 20v-6z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5.25 17a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9 2.75a.25.25 0 00-.25.25v17c0 .138.112.25.25.25h10a.25.25 0 00.25-.25V3a.25.25 0 00-.25-.25H9zM7.25 3c0-.966.784-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75v17A1.75 1.75 0 0119 21.75H9A1.75 1.75 0 017.25 20V3z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M13 5h-2v2h2V5zM17 5h-2v2h2V5zM13 8.5h-2v2h2v-2zM17 8.5h-2v2h2v-2zM17 12h-2v2h2v-2zM17 15.5h-2v2h2v-2z"
      />
    </svg>
  )
}
